// extracted by mini-css-extract-plugin
var _1 = "DetailPreviewDescriptionContainer-module__container--REaiT";
var _2 = "DetailPreviewDescriptionContainer-module__referenceContainer--vOXck";
var _3 = "DetailPreviewDescriptionContainer-module__withGradientMask--CxnHv";
export { _1 as "container", _2 as "referenceContainer", _3 as "withGradientMask" }
